import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'
export default class UrlShortened extends ApiBase {
    constructor (store) {
        const path = ACTIVE_BASE_REST + '/url/shortened'
        super(store, path)
    }
}